// Core modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Application modules
import { AppMaterialModule } from '@app/app-material.module';
import { NgApexchartsModule } from 'ng-apexcharts';

// Application components
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { TranslateModule } from '@ngx-translate/core';
import { GoogleMapsModule } from '@angular/google-maps';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    AppMaterialModule,
    NgApexchartsModule,
    GoogleMapsModule,
    TranslateModule,
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    AppMaterialModule,
    NgApexchartsModule,
    HeaderComponent,
    FooterComponent,
    GoogleMapsModule,
    TranslateModule
  ]
})
export class SharedModule { }
